var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50138 5.34086C4.19638 5.34086 3.89738 5.19412 3.70038 4.91554C3.36838 4.44557 3.45838 3.77888 3.90038 3.42693L7.90038 0.237062C8.24638 -0.0393939 8.72238 -0.046837 9.07538 0.217923L13.0754 3.21002C13.5274 3.54815 13.6364 4.21164 13.3184 4.69119C13.0004 5.17073 12.3774 5.28769 11.9254 4.94957L9.49714 3.13328C9.49904 3.16002 9.5 3.18703 9.5 3.21429V11.7206C9.5 12.3076 9.053 12.7839 8.5 12.7839C7.947 12.7839 7.5 12.3076 7.5 11.7206V3.21477L5.10038 5.1282C4.92038 5.27175 4.71038 5.34086 4.50138 5.34086ZM14.5 15.9738V14.9105C14.5 14.3257 14.95 13.8472 15.5 13.8472C16.05 13.8472 16.5 14.3257 16.5 14.9105V17.0371C16.5 17.6219 16.05 18.1004 15.5 18.1004H1.5C0.95 18.1004 0.5 17.6219 0.5 17.0371V14.9105C0.5 14.3257 0.95 13.8472 1.5 13.8472C2.05 13.8472 2.5 14.3257 2.5 14.9105V15.9738H14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ae8b06b3bb849294f6a8cbde9fc0bb96.svg";
export { ForwardRef as ReactComponent };